import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { LEGAL_ENTITY } from '@shared/legal/entity';

export { LEGAL_ENTITY };

/** Shell for legal documents: readable measure, muted chrome, RU-first.
 *  Юр. реквизиты подставляются в одном месте — LEGAL_ENTITY (@shared/legal/entity). */
export default function LegalPage({ title, updated, children }: { title: string; updated: string; children: ReactNode }) {
  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '32px 20px 80px', lineHeight: 1.65, color: 'var(--text, #e6edf3)' }}>
      <Link to="/" style={{ color: 'var(--accent, #4a9eff)', fontSize: 14 }}>← adamar.app</Link>
      <h1 style={{ fontSize: 26, margin: '16px 0 4px' }}>{title}</h1>
      <div style={{ color: 'var(--muted, #8b949e)', fontSize: 13, marginBottom: 24 }}>
        Редакция от {updated} · {LEGAL_ENTITY.name} · {LEGAL_ENTITY.email}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, fontSize: 15 }}>{children}</div>
    </div>
  );
}

export const H = ({ children }: { children: ReactNode }) => (
  <h2 style={{ fontSize: 18, margin: '14px 0 0' }}>{children}</h2>
);
